import { USER_EVENTS } from '@shared/core/user-events'
import { FC } from 'react'
import { Link } from 'react-router-dom'
import { useHasUserEvent } from 'src/modules/user-events/use-has-user-event'
import { useBookingOnboarding } from 'src/modules/user/hooks/use-booking-onboarding'
import classes from './dashboard-wrapper.module.scss'

export const BookingMessageBox: FC = () => {
  const { data: hasDismissedEvent, isLoading: isDismissedLoading } = useHasUserEvent(
    USER_EVENTS.APPOINTMENT_BOOKING_DISMISSED,
  )
  const { data: bookingOnboarding, isLoading: isBookingOnboardingLoading } = useBookingOnboarding()

  if (
    isDismissedLoading ||
    isBookingOnboardingLoading ||
    hasDismissedEvent ||
    bookingOnboarding?.onboarding_completed
  ) {
    return null
  }

  return (
    <div className={classes.bookingMessageBox}>
      <div className={classes.bookingMessageText}>
        <span className={classes.newRibbon}>New</span> Set up your booking page and let clients schedule appointments
        based on your availability!
      </div>
      <Link to="/dashboard/settings?tab=booking-page" className={classes.getStartedLink}>
        Get Started
      </Link>
    </div>
  )
}
